module.exports = __webpack_public_path__ + "img/pharmaceutical.3f6a7d0f.webp";